import { jsx as l, jsxs as g, Fragment as o } from "react/jsx-runtime";
import { c as y } from "./clsx.OuTLNxxd.js";
import { u as v } from "./use-sitecore-context.C7g4vcbm.js";
import { RichText as T } from "@sitecore-jss/sitecore-jss-nextjs";
import { B as j } from "./banner-wrapper.liD2TFKV.js";
import { B as N } from "./button-link.Cv6YTl23.js";
const $ = ({
  dataTestId: b,
  className: t,
  title: u,
  description: x,
  breadcrumbs: p,
  withBreadcrumbs: B,
  makeAnAppointmentLink: e,
  findALocationLink: r,
  findAClassOrEventLink: a
}) => {
  const {
    sitecoreContext: {
      siteAttributes: { isCorporate: w },
      route: s
    }
  } = v(), c = w && ((s == null ? void 0 : s.templateName) === "Generic Landing" || (s == null ? void 0 : s.templateName) === "Generic Detail"), h = !(e != null && e.value) && !(a != null && a.value) && !(r != null && r.value), d = c ? "col-lg-9" : h ? "col-12" : "col-lg-8", m = c ? "neu-text-main-100" : "color-white fw-medium";
  return /* @__PURE__ */ l(
    j,
    {
      dataTestId: b,
      breadcrumbs: p,
      withBreadcrumbs: B,
      className: t,
      title: u,
      applyCorporateStyles: c,
      children: /* @__PURE__ */ g(o, { children: [
        /* @__PURE__ */ g("div", { className: `${d} py-1 pe-lg-3 px-lg-0`, children: [
          /* @__PURE__ */ l("h1", { className: y("neu-display-1 pb-2", m), children: u == null ? void 0 : u.value }),
          x != null && x.value ? /* @__PURE__ */ l(
            T,
            {
              tag: "p",
              className: y("neu-text-body", m),
              field: x,
              editable: !1
            }
          ) : null
        ] }),
        h ? null : /* @__PURE__ */ g(
          "div",
          {
            className: y(
              "py-1 pb-lg-4 ps-lg-3 pe-lg-0",
              c ? "col-lg-3" : "col-lg-4"
            ),
            children: [
              /* @__PURE__ */ l("div", { className: "pb-2", children: e != null && e.value ? /* @__PURE__ */ l(
                N,
                {
                  field: e,
                  className: "w-100 text-center",
                  kind: c ? "secondary" : "tertiary-plain"
                }
              ) : null }),
              /* @__PURE__ */ l("div", { className: "pb-2", children: r != null && r.value ? /* @__PURE__ */ l(
                N,
                {
                  field: r,
                  className: "w-100 text-center",
                  kind: c ? "secondary" : "tertiary-plain"
                }
              ) : null }),
              /* @__PURE__ */ l("div", { className: "pb-2", children: a != null && a.value ? /* @__PURE__ */ l(
                N,
                {
                  field: a,
                  className: "w-100 text-center",
                  kind: c ? "secondary" : "tertiary-plain"
                }
              ) : null })
            ]
          }
        )
      ] })
    }
  );
};
export {
  $ as T
};
